import React from 'react';

type YouTubeVideoProps = {
  videoId: string;
  title?: string;
};

const YouTubeVideo: React.FC<YouTubeVideoProps> = ({
  videoId,
  title = 'Video',
}) => {
  if (!videoId) return null;

  const embedUrl = `https://www.youtube.com/embed/${videoId}`;

  return (
    <div className="tw-aspect-videoEmbed tw-w-full tw-rounded-2xl tw-bg-gray-300">
      <iframe
        className="tw-block tw-h-full tw-w-full tw-rounded-2xl"
        src={embedUrl}
        title={title}
        frameBorder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
        referrerPolicy="origin"
        allowFullScreen
        loading="lazy"
      />
    </div>
  );
};

export default YouTubeVideo;
